import React from 'react';
import './styles.css';

const SkeletonLoader = ({ type = 'card', count = 1, className = '' }) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div className={`skeleton-card ${className}`}>
            <div className="skeleton-header">
              <div className="skeleton-avatar"></div>
              <div className="skeleton-text-group">
                <div className="skeleton-text skeleton-title"></div>
                <div className="skeleton-text skeleton-subtitle"></div>
              </div>
            </div>
            <div className="skeleton-content">
              <div className="skeleton-text skeleton-line"></div>
              <div className="skeleton-text skeleton-line"></div>
              <div className="skeleton-text skeleton-line short"></div>
            </div>
            <div className="skeleton-footer">
              <div className="skeleton-button"></div>
            </div>
          </div>
        );
      
      case 'dashboard':
        return (
          <div className={`skeleton-dashboard ${className}`}>
            <div className="skeleton-stats">
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-icon"></div>
                <div className="skeleton-stat-content">
                  <div className="skeleton-text skeleton-stat-number"></div>
                  <div className="skeleton-text skeleton-stat-label"></div>
                </div>
              </div>
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-icon"></div>
                <div className="skeleton-stat-content">
                  <div className="skeleton-text skeleton-stat-number"></div>
                  <div className="skeleton-text skeleton-stat-label"></div>
                </div>
              </div>
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-icon"></div>
                <div className="skeleton-stat-content">
                  <div className="skeleton-text skeleton-stat-number"></div>
                  <div className="skeleton-text skeleton-stat-label"></div>
                </div>
              </div>
            </div>
            <div className="skeleton-cards-grid">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="skeleton-card">
                  <div className="skeleton-card-icon"></div>
                  <div className="skeleton-text skeleton-card-title"></div>
                  <div className="skeleton-text skeleton-card-description"></div>
                  <div className="skeleton-button"></div>
                </div>
              ))}
            </div>
          </div>
        );
      
      case 'list':
        return (
          <div className={`skeleton-list ${className}`}>
            {Array.from({ length: count }).map((_, i) => (
              <div key={i} className="skeleton-list-item">
                <div className="skeleton-avatar small"></div>
                <div className="skeleton-text-group">
                  <div className="skeleton-text skeleton-title"></div>
                  <div className="skeleton-text skeleton-subtitle"></div>
                </div>
                <div className="skeleton-button small"></div>
              </div>
            ))}
          </div>
        );
      
      default:
        return <div className={`skeleton-default ${className}`}></div>;
    }
  };

  if (count > 1) {
    return (
      <div className="skeleton-container">
        {Array.from({ length: count }).map((_, i) => (
          <React.Fragment key={i}>{renderSkeleton()}</React.Fragment>
        ))}
      </div>
    );
  }

  return <div className="skeleton-container">{renderSkeleton()}</div>;
};

export default SkeletonLoader;
